import { render, staticRenderFns } from "./GiftKakaoReg.vue?vue&type=template&id=badaa052&"
import script from "./GiftKakaoReg.vue?vue&type=script&lang=js&"
export * from "./GiftKakaoReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('badaa052')) {
      api.createRecord('badaa052', component.options)
    } else {
      api.reload('badaa052', component.options)
    }
    module.hot.accept("./GiftKakaoReg.vue?vue&type=template&id=badaa052&", function () {
      api.rerender('badaa052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/popup/GiftKakaoReg.vue"
export default component.exports